import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=61a15f97&"
import script from "./questionItem.vue?vue&type=script&lang=js&"
export * from "./questionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports